export default [
  {
    path: '/patient-records/:patientId',
    name: 'PatientRecords',
    component: () => import('@/views/PatientRecords/PatientRecords'),
    meta: {
      title: 'headerTitles["Patient Records"]',
    },
  },
  {
    path: '/patient-records/measurment/:patientId/:packageName',
    name: 'PatientRecordsMeasurement',
    component: () => import('@/views/PatientRecords/PatientRecordsMeasurement'),
    meta: {
      title: 'headerTitles["Patient Measurements"]',
    },
  },
  {
    path: '/patient-records/logs/:patientId/',
    name: 'PatientRecordsLog',
    component: () => import('@/views/PatientRecords/PatientActivityLog'),
    meta: {
      title: 'headerTitles["Patient Logs"]',
    },
  },
];
